import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Catalogue from "@/pages/Catalogue";
import ProjectDetail from "@/pages/ProjectDetail";
import KycPage from "@/pages/KycPage";
import EvaluationPage from "@/pages/EvaluationPage";
import DashboardPage from "@/pages/DashboardPage";
import ConditionsPage from "@/pages/ConditionsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import FaqPage from "@/pages/FaqPage";
import CadecoBackoffice from "@/pages/admin/CadecoBackoffice";
import StudeurBackoffice from "@/pages/admin/StudeurBackoffice";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/projets" element={<Catalogue />} />
      <Route path="/projets/:id" element={<ProjectDetail />} />
      <Route path="/conditions" element={<ConditionsPage />} />
      <Route path="/confidentialite" element={<PrivacyPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/kyc" element={<ProtectedRoute><KycPage /></ProtectedRoute>} />
      <Route path="/evaluation" element={<ProtectedRoute><EvaluationPage /></ProtectedRoute>} />
      <Route path="/tableau-de-bord" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/cadeco" element={<ProtectedRoute roles={["cadeco", "admin"]}><CadecoBackoffice /></ProtectedRoute>} />
      <Route path="/studeur" element={<ProtectedRoute roles={["studeur", "admin"]}><StudeurBackoffice /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
